module.exports = __webpack_public_path__ + "static/media/css4.4348d3eb.png";